import { Route } from '@angular/router';

export const authRoute: Route = {
  path: 'auth',
  loadComponent: () => import('./auth.component').then((c) => c.AuthComponent),
  children: [
    {
      path: 'login',
      loadComponent: () => import('./sign-in/sign-in.component').then((c) => c.SignInComponent),
    },
    {
      path: 'login/activate-provider',
      loadComponent: () =>
        import('./check-email/check-email.component').then((c) => c.CheckEmailComponent),
    },
    {
      path: 'registration',
      children: [
        {
          path: '',
          loadComponent: () => import('./sign-up/sign-up.component').then((c) => c.SignUpComponent),
        },
        {
          path: 'check-email',
          loadComponent: () =>
            import('./check-email/check-email.component').then((c) => c.CheckEmailComponent),
        },
        {
          path: 'otp',
          loadComponent: () => import('./otp/otp.component').then((c) => c.OtpComponent),
        },
      ],
    },
    {
      path: 'otp',
      loadComponent: () => import('./otp/otp.component').then((c) => c.OtpComponent),
    },
    {
      path: 'activate',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./activate/activate.component').then((c) => c.ActivateComponent),
        },
        {
          path: 'otp',
          loadComponent: () => import('./otp/otp.component').then((c) => c.OtpComponent),
        },
      ],
    },
    {
      path: 'forgot-username',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./forgot-username/forgot-username.component').then(
              (c) => c.ForgotUsernameComponent,
            ),
        },
        {
          path: 'check-email',
          loadComponent: () =>
            import('./check-email/check-email.component').then((c) => c.CheckEmailComponent),
        },
        {
          path: 'activate-provider',
          loadComponent: () =>
            import('./check-email/check-email.component').then((c) => c.CheckEmailComponent),
        },
      ],
    },
    {
      path: 'forgot-password',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./forgot-password/forgot-password.component').then((c) => c.ForgotUIPassword),
        },
        {
          path: 'otp',
          loadComponent: () => import('./otp/otp.component').then((c) => c.OtpComponent),
        },
        {
          path: 'reset',
          loadComponent: () =>
            import('./reset-password/reset-password.component').then((c) => c.ResetUIPassword),
        },
        {
          path: 'activate-provider',
          loadComponent: () =>
            import('./check-email/check-email.component').then((c) => c.CheckEmailComponent),
        },
      ],
    },
    {
      path: 'reset',
      loadComponent: () =>
        import('./reset-password/reset-password.component').then((c) => c.ResetUIPassword),
    },
  ],
};
